import Rails from '@rails/ujs'
Rails.start()

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './sites/base'
import '../css/sites.styl'
